export default __webpack_public_path__ + "static/media/ktx.b490c3b8.jpg";